import {addFilter} from "@wordpress/hooks";

function addCoverAttribute(settings, name) {
  if (typeof settings.attributes !== "undefined") {
      settings.attributes = Object.assign(settings.attributes, {
        hideOnMobile: {
          type: "boolean",
        },
        hideOnTablet: {
          type: "boolean",
        },
        hideOnDesktop: {
          type: "boolean",
        },
      });
  }
  return settings;
}

addFilter(
  "blocks.registerBlockType",
  "awp/cover-custom-attribute",
  addCoverAttribute
);